import React from 'react';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';
import { useTranslation } from 'react-i18next';

const CHECKOUT_URL = 'https://buy.stripe.com/14AfZhgasbgZ1mpgC40oM03';

// Screenshots shown below the CTA. `key` resolves copy under
// action_flows.screenshots.<key> in both locales. WebP is served first and the
// full-resolution PNG is the fallback for browsers without WebP support.
const SCREENSHOTS = [
  { key: 'list', webp: '/actionflows_list.webp', png: '/actionflows_list.png' },
  { key: 'builder', webp: '/actionflows_builder.webp', png: '/actionflows_builder.png' },
];

const ZendeskActionFlows = () => {
  const { events } = useGoogleAnalytics();
  const { t, i18n } = useTranslation();

  const handleGetGuideClick = () => {
    events.buyActionFlowsGuide(i18n.language || 'en');
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-16 w-full">
      <div className="bg-surface rounded-xl border border-line p-8 md:p-12 lg:p-16 text-center w-full">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          {t('action_flows.title')}
        </h1>
        <h2 className="text-xl md:text-2xl font-medium text-white/50 mb-8">
          {t('action_flows.subtitle')}
        </h2>
        <p className="text-lg md:text-xl text-white/70 mb-12 text-left whitespace-pre-wrap leading-relaxed max-w-5xl mx-auto">
          {t('action_flows.description')}
        </p>
        <button
          onClick={handleGetGuideClick}
          className="bg-cta hover:bg-cta-hover text-ink font-bold py-4 px-12 md:px-16 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:-translate-y-1 text-lg md:text-xl mb-16"
        >
          {t('action_flows.get_guide_button')}
        </button>

        {/* Product screenshots — list view first, then the visual builder. */}
        <div className="w-full max-w-5xl mx-auto mb-12 space-y-10">
          {SCREENSHOTS.map((shot) => (
            <figure key={shot.key} className="w-full">
              <picture>
                <source srcSet={shot.webp} type="image/webp" />
                <img
                  src={shot.png}
                  alt={t(`action_flows.screenshots.${shot.key}.alt`)}
                  loading="lazy"
                  className="w-full h-auto rounded-lg shadow-lg border border-line bg-white"
                />
              </picture>
              <figcaption className="mt-3 text-sm text-white/50">
                {t(`action_flows.screenshots.${shot.key}.caption`)}
              </figcaption>
            </figure>
          ))}
        </div>

        <p className="mt-8 text-white/50 text-sm md:text-base border-t border-line pt-8">
          {t('action_flows.contact_text')}{' '}
          <a href="mailto:contacto@easyappforz.com" className="text-accent-400 font-semibold hover:underline">
            contacto@easyappforz.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default ZendeskActionFlows;
